import { useState, useEffect, useRef } from "react";
import { Document, Page } from "react-pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Select, notification } from "antd";
import Drag from "./upload/Drag";
import { CheckSquareOutlined, CloseCircleOutlined, ZoomInOutlined, ZoomOutOutlined, InfoCircleOutlined, EditTwoTone, DeleteTwoTone } from "@ant-design/icons";
import { Translate } from "../translate";
import { getStore } from "../utils/global";
import axios from "../utils/axios";

export default function PreviewRoot({
  file,
  stamps = [],
  setStamps = () => {},
  onSuccess = () => {},
  page = 1,
  pageChange = () => {},
  onPageSizesLoaded = () => {},
  selectedUser,
  parts = [],
  allUsers = [],
  setActive,
  docs,
  actiontype,
  senderx,
  funcs,
  rendertitle,
  lockInputs = false,
  onClose,
  locked = false,
}) {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const loggedUser = getStore("user");
  const overlayRef = useRef(null);
  const activeRef = useRef(null);
  const [currentUrl, setCurrentUrl] = useState("");
  const [coords, setCoords] = useState({});
  const [myCoords, setMyCoords] = useState([]);
  const [boxes, setBoxes] = useState(stamps);
  const [stampName, setStampName] = useState("");
  const [stampCount, setStampCount] = useState(0);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [checkDelete, setCheckDelete] = useState(false);
  const [activeI, setActiveI] = useState(0);
  const [activepage, setActivepage] = useState(page);
  const [numPages, setNumPages] = useState(0);
  const [visible, setVisible] = useState(false);
  const [transform, setTransform] = useState({ scale: 1 });
  const [max, setMax] = useState({ w: 0, h: 0 });

  const calc_intersect = (activeBox, currentBoxes, activeIdx) => {
    // Define the boundaries of the box we are currently moving
    const box1 = {
      x1: activeBox.left,
      x2: activeBox.left + (activeBox.style?.width || activeBox.width),
      y1: activeBox.bottom,
      y2: activeBox.bottom + (activeBox.style?.height || activeBox.height),
    };

    // Check against every other box
    return currentBoxes.some((per, i) => {
      // Skip the box we are currently dragging and boxes on other pages
      if (i === activeIdx || per.page !== activepage) return false;

      const box2 = {
        x1: per.left,
        x2: per.left + (per.style?.width || per.width),
        y1: per.bottom,
        y2: per.bottom + (per.style?.height || per.height),
      };

      // Standard AABB (Axis-Aligned Bounding Box) intersection formula
      return !(box1.x2 <= box2.x1 || box2.x2 <= box1.x1 || box1.y2 <= box2.y1 || box2.y2 <= box1.y1);
    });
  };

  const mouseMove = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;
    const act = activeRef.current;

    if (act && overlayRef.current) {
      const { clientWidth, clientHeight } = overlayRef.current;

      let x1 = offsetX - parseInt(act.getAttribute("shiftx"));
      let y1 = clientHeight - offsetY + parseInt(act.getAttribute("shifty")) - act.clientHeight;

      // Boundary constraints
      x1 = Math.max(0, Math.min(x1, clientWidth - act.clientWidth));
      y1 = Math.max(0, Math.min(y1, clientHeight - act.clientHeight));

      setBoxes((prevBoxes) => {
        const newBoxes = [...prevBoxes];
        const targetBox = { ...newBoxes[activeI], left: x1, bottom: y1, x1, y1, page: activepage };

        // Run intersection check
        const hasCollision = calc_intersect(targetBox, newBoxes, activeI);

        // Only update if there is NO collision
        if (!hasCollision) {
          newBoxes[activeI] = targetBox;
          return newBoxes;
        }

        // If there IS a collision, return previous state (box stays put)
        return prevBoxes;
      });
    }
  };

  const mouseUp = () => {
    setStamps([...boxes]);

    overlayRef.current.style.display = "none";
  };

  const mouseDown = (ref, i) => {
    setActive && setActive(i);
    overlayRef.current.style.display = "block";
    activeRef.current = ref;
    setActiveI(i);
  };

  const setMaxBounds = () => {
    const container = document.querySelector(".upload_steps_body");
    const sides = container.getBoundingClientRect();
    setMax({ w: sides.width, h: sides.height });
  };

  useEffect(() => {
    fetchCoords();
    const url = window.location.href;
    setCurrentUrl(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setBoxes(stamps);
    getCoord();

    if (file) {
      setMaxBounds();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stamps, file]);

  const updateHandler = (e, i) => {
    let rect = e.target.getBoundingClientRect();
    const tmp = [...boxes];
    tmp.map((item, idx) => {
      if (i === idx) {
        item["width"] = rect.width;
        item["height"] = rect.height;
        item["value"] = e.target.value;
      }
      return item;
    });
    setBoxes(tmp);
    setStamps(tmp);
  };

  const getCoord = () => {
    let temp = {};
    let cnt = 0;
    let i = 0;
    while (i < stamps.length) {
      cnt++;
      if (stamps[i].unique_key.toString() === "yourSignature" || stamps[i].unique_key.toString() === "yourStamp") {
        temp[i] = {
          color: stamps[i].color,
          backgroundColor: stamps[i].color,
          description: stamps[i].description,
          drag_desc: stamps[i].drag_desc,
          drag_txt: stamps[i].drag_txt,
          height: stamps[i].height,
          icon: stamps[i].icon,
          imageid: stamps[i].imageid,
          imagetype: stamps[i].imagetype,
          left: stamps[i].left,
          msisdn: stamps[i].msisdn,
          page: stamps[i].page,
          part_index: stamps[i].part_index,
          shortname: stamps[i].shortname,
          style: stamps[i].style,
          svgurl: stamps[i].svgurl,
          bottom: stamps[i].bottom,
          type: stamps[i].type,
          uid: stamps[i].uid,
          unique_key: stamps[i].unique_key,
          value: stamps[i].value,
          width: stamps[i].width,
          x1: stamps[i].x1,
          y1: stamps[i].y1,
        };
      } else {
        temp[i] = {
          bottom: stamps[i].bottom,
          left: stamps[i].left,
          x1: stamps[i].x1,
          y1: stamps[i].y1,
          page: stamps[i].page,
          color: stamps[i].color,
          backgroundColor: stamps[i].color,
          drag_txt: stamps[i].drag_txt,
          height: stamps[i].height,
          icon: stamps[i].icon,
          key: stamps[i].key,
          name: stamps[i].name,
          style: stamps[i].style,
          type: stamps[i].type,
          unique_key: stamps[i].unique_key,
          value: stamps[i].value,
          width: stamps[i].width,
          part_index: stamps[i].part_index,
        };
      }

      i++;
    }
    setCoords(temp);
    setStampCount(cnt);
  };

  const handleSelectChange = (value) => {
    const selectedOptionIndex = myCoords.findIndex((coord) => coord.name === value);

    if (checkDelete) {
      deleteCoord(selectedOptionIndex);
    } else {
      positionStamps(selectedOptionIndex);
    }
  };

  const saveCoord = async () => {
    let temp = true;
    if (myCoords && stampName.length > 0 && stampName.length < 36) {
      myCoords.forEach((val) => {
        if (stampName === val.name) {
          notification["error"]({
            message: "Name exists!!!",
          });
          temp = false;
        }
      });
    }
    if (stampName.length > 0 && temp && stampName.length < 36) {
      try {
        await axios.post(`/client/api/user/create/coord`, {
          user_id: loggedUser.kdss_user,
          name: stampName,
          json_data: coords,
        });
        notification.success({ message: "Saved" });

        fetchCoords();
      } catch (error) {
        console.log("in error", error);
      }
    } else if (temp && stampName.length === 0) {
      temp = false;
      notification["error"]({
        message: "Enter name",
      });
    } else if (temp && stampName.length > 35) {
      notification["error"]({
        message: "Name too long, length 35",
      });
    }
  };

  const fetchCoords = async () => {
    try {
      let temp = [];
      const res = await axios.post(`/client/api/user/get/coords`, {
        user_id: loggedUser.kdss_user,
      });
      const resData = res?.data;

      if (resData) {
        for (const [key, value] of Object.entries(resData)) {
          if (key.toString() !== "code" && key.toString() !== "message") {
            temp.push(value);
          }
        }
      }
      setMyCoords(temp);
    } catch (error) {
      if (error.status === 461) {
        setMyCoords([]);
      }
      console.log("coord fetch error: empty fix here be", error);
    }
  };

  const deleteCoord = async (val) => {
    try {
      await axios.post(`/client/api/user/delete/coord`, {
        id: myCoords[val].id,
      });

      notification.success({ message: "Deleted" });

      fetchCoords();
    } catch (error) {
      console.log("coord fetch error", error);
    }
  };

  const positionStamps = (val) => {
    const coordData = myCoords[val]?.json_data;
    if (!coordData) return;

    try {
      const vals = Object.values(JSON.parse(coordData));
      const partIndices = vals.map((el) => el.part_index);
      const numberOfParts = new Set(partIndices).size;

      // Validate participant count
      if (numberOfParts > allUsers.length) {
        notification.error({ message: "Participant missing" });
        return;
      }

      const tmpBoxes = vals
        .map((val) => {
          const { part_index, unique_key, msisdn } = val;
          const matchingUser = allUsers[part_index];

          // Validate user matching for signature/stamp types
          if ((unique_key === "yourSignature" || unique_key === "yourStamp") && msisdn !== matchingUser?.msisdn) {
            notification.error({ message: "User order not matching" });
            return null;
          }

          const baseFields = {
            sumx: 1,
            page: val.page,
            part_index: val.part_index,
            color: val.color,
            backgroundColor: val.backgroundColor,
            left: val.left,
            bottom: val.bottom,
            width: val.width,
            height: val.height,
            style: val.style,
            type: val.type,
            unique_key: val.unique_key,
            value: val.value,
            drag_txt: val.drag_txt,
            x1: val.x1,
            y1: val.y1,
          };

          if (unique_key === "yourSignature" || unique_key === "yourStamp") {
            return {
              ...baseFields,
              description: val.description,
              drag_desc: val.drag_desc,
              icon: val.icon,
              imageid: val.imageid,
              imagetype: val.imagetype,
              msisdn: val.msisdn,
              shortname: val.shortname,
              svgurl: val.svgurl,
              uid: val.uid,
            };
          }

          return {
            ...baseFields,
            uid: matchingUser?.uid,
            msisdn: matchingUser?.msisdn,
            username: matchingUser?.name,
            name: val.name,
            icon: val.icon,
            key: val.key,
          };
        })
        .filter(Boolean);

      setBoxes(tmpBoxes);
      setStamps(tmpBoxes);
    } catch (error) {
      console.error("Error positioning stamps:", error);
      notification.error({ message: "Error loading coordinates" });
    }
  };

  const pdfTransformer = (newScale) => {
    const t = { ...transform };
    if (newScale > 0.2 && newScale < 3) {
      t.scale = newScale;
    }

    const container = document.querySelector(".my_pdf");
    container.style.zoom = t.scale;

    setTransform(t);
  };

  return (
    <div className="review_root">
      <div className="review_pdf_fixed_header">
        <EditTwoTone
          onClick={() => setVisible(true)}
          style={{
            fontSize: "200%",
            paddingTop: "10px",
            paddingLeft: "10px",
          }}
        />
        <div className="review_pdf_tools">
          <div
            className="review_pdf_container_back"
            onClick={() => {
              if (activepage > 1) {
                setActivepage((prev) => prev - 1);
                pageChange(activepage - 1);
              }
            }}>
            <FontAwesomeIcon size="3x" icon="caret-left" />
          </div>
          <div className="review_pdf_container_total">
            <div>{Translate[ln].NewDoc.Customizations.Page}:</div> &nbsp;&nbsp;
            <Input
              onFocus={(event) => {
                event.target.select();
              }}
              style={{ width: 40, textAlign: "center" }}
              value={activepage}
              onChange={(data) => {
                let val = data.target.value * 1;
                if (!isNaN(val) && val > 0 && numPages >= val) {
                  setActivepage(val);
                  pageChange(val);
                }
              }}
            />
            &nbsp; <div>of</div>&nbsp;<b>{numPages}</b>
          </div>
          <div
            className="review_pdf_container_forward"
            onClick={() => {
              if (numPages > activepage) {
                setActivepage((prev) => prev + 1);
                pageChange(activepage + 1);
              }
            }}>
            <FontAwesomeIcon size="3x" icon="caret-right" />
          </div>
          {currentUrl.includes("upload/2") && (
            <div
              style={{
                paddingTop: 15,
                display: "flex",
                width: "60%",
              }}>
              {stampCount ? (
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "center",
                  }}>
                  <Input
                    placeholder="name"
                    style={{
                      width: "100%",
                      height: "72%",
                      textAlign: "center",
                    }}
                    maxLength={35}
                    value={stampName}
                    onChange={(data) => {
                      setStampName(data.target.value);
                    }}
                  />
                  <Button onClick={saveCoord}>Save</Button>
                </div>
              ) : (
                <div
                  style={{
                    width: "70%",
                    height: "72%",
                    textAlign: "center",
                  }}></div>
              )}
              <Select
                placeholder="Select"
                style={{
                  marginLeft: "10%",
                  textAlign: "center",
                  width: "70%",
                }}
                onChange={handleSelectChange}>
                {myCoords.map((option, index) => (
                  <Select.Option
                    key={index}
                    value={option.name}
                    onMouseEnter={() => setHoveredOption(option)}
                    onMouseLeave={() => setHoveredOption(null)}
                    style={{ cursor: "auto" }}>
                    <div>
                      <div>{option.name}</div>
                      {hoveredOption === option && (
                        <DeleteTwoTone
                          onMouseEnter={() => setCheckDelete(true)}
                          onMouseLeave={() => setCheckDelete(false)}
                          type="delete"
                          style={{
                            size: "large",
                            cursor: "pointer",
                            position: "absolute",
                            right: 10,
                            top: 10,
                          }}
                        />
                      )}
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </div>
          )}
          <div className="pdf_controller">
            {transform.scale !== 1 && <Button icon={<CloseCircleOutlined />} shape="circle" onClick={() => pdfTransformer(1)} />}
            <Button icon={<ZoomInOutlined />} shape="circle" onClick={() => pdfTransformer(transform.scale + 0.2)} type="primary" />
            <Button icon={<ZoomOutOutlined />} shape="circle" onClick={() => pdfTransformer(transform.scale - 0.2)} type="primary" />
          </div>
        </div>
        {onClose && (
          <div className="review_pdf_fixed_close" onClick={onClose}>
            <FontAwesomeIcon icon="times" size="3x" />
          </div>
        )}
      </div>
      <div className="upload_steps_body" style={{ paddingTop: 30 }}>
        {visible && <div className="opacity_overlay" onClick={() => setVisible(false)} />}
        <div
          className="preview_info_overlay"
          style={{
            transform: `translateX(${visible ? "0" : "-100vw"})`,
          }}>
          <div className="preview_info_contents">
            <div>
              <span style={{ opacity: "0.7" }}>Status: </span>
              {docs?.status}
            </div>
            {docs?.status === "WAITING" && actiontype === "signer" ? (
              <div className="step1_actions">
                <button
                  className="btn"
                  bg_color="5"
                  onClick={() => {
                    funcs.doc_sign(docs?.docid);
                  }}>
                  sign
                </button>
                <button
                  className="btn"
                  bg_color="6"
                  onClick={() => {
                    funcs.doc_reject(docs?.docid);
                  }}>
                  reject
                </button>
              </div>
            ) : docs?.status === "WAITING" && actiontype === "approver" ? (
              <div className="step1_actions">
                <div>
                  <span style={{ opacity: "0.7" }}>Status: </span>
                  {docs?.status}
                </div>
                <button
                  className="btn"
                  bg_color="5"
                  onClick={() => {
                    funcs.doc_approve(docs?.docid);
                  }}>
                  approve
                </button>
                <button
                  className="btn"
                  bg_color="6"
                  onClick={() => {
                    funcs.doc_reject(docs?.docid);
                  }}>
                  reject
                </button>
              </div>
            ) : (
              docs?.status === "WAITING" &&
              actiontype === "copy" && (
                <div className="preview_reminder">
                  <InfoCircleOutlined />
                  You have no permission to sign , approve or reject this document.
                </div>
              )
            )}
            <div className="step1_user_detail" style={{ marginTop: 20 }}>
              <div className="step1_user_detail_title">{Translate[ln].NewDoc.Preview.Sender}</div>
              <div className="step1_user_detail_body">
                <div className="user_dropdown_name">{senderx?.name}</div>
                <div className="user_dropdown_mobile">{senderx?.msi}</div>
                <div className="user_dropdown_email" color="1">
                  {senderx?.email}
                </div>
              </div>
            </div>
            {parts?.map((per, i) => {
              return (
                <div key={i} className="step1_user_detail" style={{ marginTop: 20 }}>
                  <div
                    className="step1_user_detail_title"
                    style={{
                      background: per?.bg_color,
                      opacity: rendertitle(i) === "Signed" ? "0.6" : "1",
                    }}>
                    {rendertitle(i)}
                    <div className="step1_user_signed" issigned={per?.is_signed}>
                      {rendertitle(i) === "Signed" ? null : <CheckSquareOutlined />}
                    </div>
                  </div>
                  <div className="step1_user_detail_body">
                    <div className="user_dropdown_name">{per?.name}</div>
                    <div className="user_dropdown_mobile">{per?.msisdn}</div>
                    <div className="user_dropdown_email" color="1">
                      {per?.email}
                    </div>
                  </div>
                </div>
              );
            })}
            <div onClick={() => setVisible(false)} className="preview_close_x btn">
              X
            </div>
          </div>
        </div>
        <div
          className="review_pdf_container"
          style={{
            maxWidth: max.w === 0 ? "100%" : max.w,
          }}>
          <Document
            id="pdf-cont"
            file={file}
            onLoadSuccess={async (pdf) => {
              setNumPages(pdf.numPages);

              const sizes = await Promise.all(
                Array.from({ length: pdf.numPages }, async (_, i) => {
                  const page = await pdf.getPage(i + 1);
                  const viewport = page.getViewport({ scale: 1 });
                  return {
                    pageNumber: i + 1,
                    width: viewport.width,
                    height: viewport.height,
                  };
                }),
              );

              // === NEW: Send sizes to parent ===
              if (onPageSizesLoaded) {
                if (sizes.length > 0) {
                  // Most PDFs have same size on all pages, so we take first page
                  // If pages can have different sizes, you can send the full array instead
                  const firstPage = sizes[0];
                  onPageSizesLoaded({
                    w: firstPage.width,
                    h: firstPage.height,
                    // Optional: send full data if needed later
                    allPages: sizes,
                  });
                } else {
                  // Fallback to A4
                  onPageSizesLoaded({ w: 595, h: 842 });
                }
              }

              if (onSuccess) onSuccess();
            }}
            style={{ background: "red" }}
            className="my_pdf">
            <Page height={1000} pageNumber={activepage} rotate={0} scale={1}>
              <div className="boxes_wrapper">
                <div
                  className="boxes_drag_area"
                  onDragOver={(e) => {
                    e.preventDefault();
                  }}>
                  {boxes?.map(
                    (per, i) =>
                      per.page === activepage && (
                        <Drag
                          dragstart={(ref) => {
                            mouseDown(ref, i);
                          }}
                          {...per}
                          key={i + "_" + per.drag_txt}
                          index={i}
                          disabled={per.uid !== selectedUser?.user_id}
                          locked={locked}
                          value={per.value}
                          updateHandler={(ref) => {
                            updateHandler(ref, i);
                          }}
                          lockInputs={lockInputs}
                        />
                      ),
                  )}
                  <div className="drag_footer_box">Footer text</div>
                  <div id="app_overlay" onMouseMove={mouseMove} onMouseUp={mouseUp} ref={overlayRef} />
                </div>
              </div>
            </Page>
          </Document>
        </div>
      </div>
    </div>
  );
}
